var map = {
	"./732trigroup.png": 6690,
	"./burrowingowl.jpg": 1560,
	"./califquail.png": 1642,
	"./cardioidmodel.png": 3858,
	"./cayley_cubic_1.png": 960,
	"./cayley_cubic_2.png": 3701,
	"./chuckwillswidow.png": 6817,
	"./clebsch_cubic.png": 2990,
	"./cn.png": 3127,
	"./coaldumper.jpg": 4840,
	"./creeper.png": 2376,
	"./cubefivecmpd.png": 3959,
	"./diamondcubic.png": 3865,
	"./digamma.png": 4727,
	"./gamma.png": 8584,
	"./gaussianrationals.png": 3592,
	"./goursat_cubic.png": 5882,
	"./harlequinduck.png": 8710,
	"./heptaband.png": 6733,
	"./heptahalf.png": 9289,
	"./icosa.png": 8934,
	"./icosahedral_sph_inv.png": 4548,
	"./islamictiling.png": 3357,
	"./kummer.png": 679,
	"./lambertw.png": 3028,
	"./longtail2.png": 6629,
	"./mathcurve_cubic.png": 5386,
	"./merganser.png": 9327,
	"./millpumps.png": 5531,
	"./millwindow.png": 4267,
	"./monastery.png": 1387,
	"./newtonfractal1.png": 2908,
	"./newtonfractal2.png": 6890,
	"./newtonfractal3.png": 8689,
	"./newtonfractal4.png": 3966,
	"./newtonfractal5.png": 9584,
	"./newtonfractal6.png": 9364,
	"./osprey.png": 3258,
	"./oystercatcher.png": 6683,
	"./parakeets.png": 4715,
	"./purplegallinule.png": 2804,
	"./railbridge.png": 2951,
	"./redthroatedloon.png": 2694,
	"./sanderling.png": 1243,
	"./servers.png": 8408,
	"./sl.png": 9899,
	"./squaremodel.png": 4994,
	"./tern.png": 5406,
	"./tetfivecmpd.png": 6564,
	"./treeswallow.png": 1852,
	"./tritrumpet.png": 5772,
	"./unityhouse.png": 3146,
	"./vermillionflycatcher.png": 8091,
	"./violetgreen.png": 9013,
	"./wada.png": 5302,
	"./woodduck.png": 448,
	"./yellowthroat.png": 5552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6658;